'use client'

import apolloLogger from 'apollo-link-logger'

export function makeApolloLoggerLink() {
  if (apolloLogger) {
    return apolloLogger
  }
}
